import React from 'react';

const FranchiseForum = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 font-sans overflow-hidden">
      {/* Header */}
     <div className="w-screen h-64 md:h-[600px] border-[3px] border-[#35A93E]">
        <img
          src="/forum.jpeg"
          alt="Forum Banner"
          className="w-full h-full object-contain md:object-cover"
        />
      </div>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        {/* Welcome Section */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10 transform hover:scale-[1.01] transition-transform duration-300">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Welcome to the LifeOnPlus Franchise Forum</h2>
          <p className="text-gray-600 leading-relaxed">
            Your space to engage with the LifeOnPlus business ecosystem. Whether you're exploring our franchise models or already onboard, this forum is designed to answer your questions, spark collaborations, and grow together.
          </p>
        </section>

        {/* Forum Topics */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Popular Forum Topics</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Franchise Queries */}
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#35A93E] mb-3">Franchise Queries</h3>
              <p className="text-gray-600 mb-4">Ask questions about investment, ROI, training, or regional availability for:</p>
              <ul className="list-disc pl-5 text-gray-700 space-y-1">
                <li>Body Recharge Stations</li>
                <li>Health Kiosks</li>
                <li>Quick Test Units</li>
                <li>Express Medical Test Centres</li>
                <li>Remote Patient Monitoring (RPM) Hubs</li>
              </ul>
            </div>

            {/* Business & Operations */}
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#35A93E] mb-3">Business & Operations</h3>
              <p className="text-gray-600">Discuss setup timelines, interior design guidelines, SOPs, staffing, and licensing.</p>
            </div>

            {/* Partner Support */}
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#35A93E] mb-3">Partner Support</h3>
              <p className="text-gray-600">Get help from our support team or share your feedback, concerns, or challenges.</p>
            </div>

            {/* Announcements */}
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#35A93E] mb-3">Announcements</h3>
              <p className="text-gray-600">Stay updated on partner events, webinar invites, new service launches, and regional franchise meets.</p>
            </div>

            {/* Share Your Experience */}
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#35A93E] mb-3">Share Your Experience</h3>
              <p className="text-gray-600">If you are already a partner, inspire others by sharing your success story.</p>
            </div>
          </div>
        </section>

        {/* Start a Conversation */}
        <section className="bg-gradient-to-r from-[#35A93E] to-green-500 text-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold mb-4">Start a Conversation</h2>
          <p className="leading-relaxed mb-6">
            Have a question? Curious about your city’s availability? Interested in multi-unit ownership? Drop your message below — Our team and community will respond quickly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button className="bg-white text-[#35A93E] font-semibold px-6 py-3 rounded-full hover:bg-gray-100 transition-colors duration-300">Post a New Topic</button>
            <button className="bg-white text-[#35A93E] font-semibold px-6 py-3 rounded-full hover:bg-gray-100 transition-colors duration-300">Reply to a Thread</button>
            <button className="bg-white text-[#35A93E] font-semibold px-6 py-3 rounded-full hover:bg-gray-100 transition-colors duration-300">Join the Community</button>
          </div>
        </section>

        {/* Forum Guidelines */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Forum Guidelines</h2>
          <ul className="list-disc pl-5 text-gray-700 space-y-2">
            <li>Be respectful and professional</li>
            <li>No promotional posts or spam</li>
            <li>Use the correct category while posting</li>
            <li>Our moderators may edit or move posts for clarity</li>
          </ul>
        </section>

        {/* Direct Help */}
        <section className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Need Direct Help?</h2>
          <p className="text-gray-700">
            For confidential franchise inquiries or a one-on-one consultation, contact{' '}
            <a href="mailto:franchisee@lifeonplus.com" className="text-[#35A93E] hover:underline font-semibold">
              franchisee@lifeonplus.com
            </a>
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-[#35A93E] to-green-600 text-white py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">© 2025 LifeOnPlus Franchise Forum. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default FranchiseForum;